import type { SciMailKind, SciMailWindowsMap } from '../@types/SciMail';

const KEY_PATTERN = /^(\d{4}):([1-3])$/;

export const parseSciKeyTemplateId = (key: string | null | undefined): number | null => {
  if (!key) {return null;}
  const match = /-(\d+)$/.exec(key);
  return match ? Number.parseInt(match[1], 10) : null;
};

const sortableWindowKeys = (map: SciMailWindowsMap | undefined): string[] => {
  if (!map) {return [];}
  return Object.keys(map)
    .filter((k) => KEY_PATTERN.test(k))
    .sort();
};

/**
 * Resolve the templateKey to suggest as default for a given mailing kind from
 * the per-window choices stored on the company. Returns the templateKey of the
 * earliest upcoming window with a matching kind (lexicographic sort works
 * because keys are `${YYYY}:${idx}` with idx ∈ 1..3).
 */
export const resolveDefaultTemplateKey = (
  windowsMap: SciMailWindowsMap | undefined,
  kind: SciMailKind,
): string | null => {
  for (const key of sortableWindowKeys(windowsMap)) {
    const entry = windowsMap?.[key];
    if (entry && entry.kind === kind) {
      return entry.templateKey;
    }
  }
  return null;
};

/**
 * Convenience: resolve the default template ID (the trailing number) for a kind.
 */
export const resolveDefaultTemplateId = (
  windowsMap: SciMailWindowsMap | undefined,
  kind: SciMailKind,
): number | null => parseSciKeyTemplateId(resolveDefaultTemplateKey(windowsMap, kind));
